if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('aria-busy', 'true');

        const formData = new FormData(this.form);
        window.SweetbarPreorderProperties?.normalizeFormData(formData);
        const giftPicker = this.querySelector('sweetbar-gift-picker[data-unified-gift="true"]');
        const giftPostcards = giftPicker?.querySelector('sweetbar-gift-postcards');
        const packagingChoice = giftPicker?.selected;
        const postcardChoice = giftPostcards?.selected;
        const hasGiftSelection = Boolean(packagingChoice || postcardChoice);

        if (hasGiftSelection) {
          try {
            const mainId = Number(formData.get('id'));
            const mainQuantity = Number(formData.get('quantity') || 1);
            if (!Number.isSafeInteger(mainId) || mainId < 1 || !Number.isSafeInteger(mainQuantity) || mainQuantity < 1) {
              throw new Error('Invalid product selection');
            }

            const mainItem = { id: mainId, quantity: mainQuantity };
            const mainProperties = {};
            for (const [key, value] of formData.entries()) {
              const match = /^properties\[(.+)\]$/.exec(key);
              if (match && String(value).length) mainProperties[match[1]] = String(value);
            }
            if (Object.keys(mainProperties).length) mainItem.properties = mainProperties;
            const sellingPlan = formData.get('selling_plan');
            if (sellingPlan) mainItem.selling_plan = sellingPlan;

            const items = [mainItem];

            if (packagingChoice) {
              const packagingId = Number(packagingChoice.dataset.variantId);
              if (!Number.isSafeInteger(packagingId) || packagingId < 1) throw new Error('Invalid gift packaging');
              const packagingProperties = {};
              if (giftPostcards?.dataset.parentId) packagingProperties._sb_natal_parent_product_id = giftPostcards.dataset.parentId;
              items.push({
                id: packagingId,
                quantity: 1,
                ...(Object.keys(packagingProperties).length ? { properties: packagingProperties } : {}),
              });
            }

            if (postcardChoice) {
              const postcardId = Number(postcardChoice.dataset.variantId);
              if (!Number.isSafeInteger(postcardId) || postcardId < 1) throw new Error('Invalid Christmas card');
              const message = (giftPostcards?.message?.value || '').trim();
              if (message.length > 180 || /[<>]|\/uploads\//.test(message)) throw new Error('Invalid card message');
              const postcardProperties = {};
              if (giftPostcards?.dataset.parentId) postcardProperties._sb_natal_parent_product_id = giftPostcards.dataset.parentId;
              if (giftPostcards?.dataset.parentTitle && giftPostcards?.dataset.forProperty) {
                postcardProperties[giftPostcards.dataset.forProperty] = giftPostcards.dataset.parentTitle;
              }
              if (message && giftPostcards?.dataset.messageProperty) {
                postcardProperties[giftPostcards.dataset.messageProperty] = message;
              }
              items.push({
                id: postcardId,
                quantity: 1,
                ...(Object.keys(postcardProperties).length ? { properties: postcardProperties } : {}),
              });
            }

            const payload = { items };
            if (this.cart) {
              const sections = this.cart.getSectionsToRender().map((section) => section.id);
              payload.sections = sections;
              payload.sections_url = window.location.pathname + window.location.search;
              this.cart.setActiveElement(document.activeElement);
            }

            const response = await fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(payload),
            });
            const result = await response.json();

            if (!response.ok || result.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: String(mainId),
                errors: result.errors || result.description,
                message: result.message,
              });
              this.handleErrorMessage(result.description || result.message || 'Não foi possível adicionar ao carrinho.');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const primary = Array.isArray(result.items)
              ? (result.items.find((item) => Number(item.variant_id || item.id) === mainId) || result.items[0])
              : null;
            if (primary) {
              result.id = primary.id || primary.variant_id;
              result.key = primary.key;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: String(mainId),
              cartData: result,
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(result);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(result);
            }
            return;
          } catch (error) {
            console.error(error);
            this.handleErrorMessage('Não foi possível adicionar o produto e o presente ao carrinho.');
            this.error = true;
            return;
          } finally {
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
